import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../../css/grid.css';
import Graph from './LayoutDraggable'
import { DropTarget, ConnectDropTarget, DropTargetConnector, DropTargetMonitor, useDrop} from 'react-dnd'
import * as globals from '../Globals/Globals'
import ItemTypes from '../ItemTypes';
import ErrorBoundary from 'react-error-boundary';

interface GraphElement {
    clientOffsetX:number,
    clientOffsetY:number,
    yaxis:string,
    content:string,
    id:string,
    type:string,
    datatype:string
}

interface  GraphTargetProps{
  
}
function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

const GraphTarget: React.FC<GraphTargetProps> = ({  }) => {
        const [, drop] = useDrop({
            accept: ItemTypes.Attributes,
            drop(item, monitor: DropTargetMonitor){
                const didDrop = monitor.didDrop()
                if (didDrop) {
                    return
                  }
                var content:string = monitor.getItem().content;
                var id:string = monitor.getItem().id;
                var yaxis:string = "Count";
                const node = document.getElementById(id) as Element
                console.log('_id____',id,node)
            
                const delta = monitor.getClientOffset();
                console.log(item , delta.x, delta.y)
                const left = Math.round(delta.x);
                const top = Math.round(delta.y);
                console.log('globals.dataset.datasetTypesMap',globals.dataset.datasetTypesMap)
                var graph:GraphElement = {
                        clientOffsetX: left - node.getBoundingClientRect().left -250, 
                        clientOffsetY: top - node.getBoundingClientRect().right -100 ,
                        yaxis: yaxis,
                        content: content,
                        id:id,
                        type:'graph',
                        datatype:   globals.dataset.datasetTypesMap.get(id)
                }
                console.log('graphgraph',graph)
                return graph
            }
        })
        return (
            <ErrorBoundary>
                <div className="Graph" id="graph" ref={drop} >
                
                </div>
            </ErrorBoundary>
        );
}

export default GraphTarget;
